import React, { useEffect, useState, FC } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Button, makeStyles, Theme, createStyles } from '@material-ui/core';
import GlobalStyles from "../../styles/GlobalStyles";
import { logout } from '../../flux/actions/auth-actions';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        primaryButton: {
            margin: theme.spacing(0, 1, 0),
            background: GlobalStyles.primaryColor,
            "&:hover": {
                backgroundColor: GlobalStyles.secondaryColor
            }
        }
    })
);

export const ModalLogout: FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [today, setToday] = useState(new Date().getTime());
    const [isOpen, setIsOpen] = useState(false);

    const { user } = useSelector((state: any) => state.authReducer);

    useEffect(() => {
        if (user.token && (today >= (user.exp * 1000))) {
            setToday(user.exp);
            setIsOpen(true);
        }
    }, [user]);

    return (
        <Dialog open={isOpen}>
            <DialogTitle>
                Token expirado
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Tu sesión ha expirado. Inicia sesión nuevamente.
                </DialogContentText>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <Button color="secondary" variant="contained" className={classes.primaryButton} onClick={() => dispatch(logout())}>
                        Cerrar sesión
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}
